import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchPaymentHistoryDetails } from "../../store/actions/payment.action";
import dayjs from "@lib/dayjs";
import DownloadIcon from "../../assets/svg/DownloadIcon";
import ChevronLeftIcon from "../../assets/svg/ChevronLeftIcon";
import { generateTransactionPDF } from "../../utils/transactionPDF";

const TransactionDetailPage = () => {
  const { id, type } = useParams();
  const dispatch = useDispatch();
  const { paymentHistoryDetails, loading: reduxLoading } = useSelector(
    (state) => state.payment
  );
  const initialized = useRef(false);
  const navigate = useNavigate();
  const domRef = useRef(null);
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    dispatch(fetchPaymentHistoryDetails(id, type));
  }, [id, type]);

  // handle pdf generation
  const handlePdfGeneration = async () => {
    if (!paymentHistoryDetails) return;

    setDownloadLoading(true);
    try {
      const success = await generateTransactionPDF(paymentHistoryDetails, type);
      if (!success) {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setDownloadLoading(false);
    }
  };
  return (
    <div ref={domRef} className="flex flex-col bg-white w-full h-full">
      <div
        //  className="grid grid-cols-3 p-4"
        className="flex items-center justify-between p-4 relative"
      >
        <button
          onClick={() => navigate('/referral/payments')}
          className="flex items-center mb-3 no-print"
        >
          <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
          <label className="text-[10px] font-medium text-primary cursor-pointer font-montserrat">
            Back to listing
          </label>
        </button>
        <h1
          className="pt-2 font-bold text-2xl absolute left-[45%] transform -translate-x-1/2"
          // className="pt-2 font-bold text-2xl pl-12"
        >
          RECEIPTS
        </h1>
        <span
          // className="pr-5 justify-self-end no-print"
          onClick={handlePdfGeneration}
          className="no-print pr-5"
        >
          <button
            className={`rounded bg-gray-100 ${
              downloadLoading
                ? "opacity-50 cursor-not-allowed animate-bounce"
                : ""
            }`}
            disabled={downloadLoading}
          >
            <DownloadIcon className={"w-9 h-9"} fill="#4d4d4d" />
          </button>
        </span>
      </div>

      <div className="flex-1 overflow-y-auto px-4 pb-4">
        {reduxLoading ? (
          <div className="gap-2.5 flex mt-16 flex-col no-print">
            {Array.from({ length: 10 }, (x, i) => i).map((key) => (
              <div key={key} className="flex justify-between">
                <div
                  style={{
                    borderWidth: 1,
                  }}
                  className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
                >
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                </div>
              </div>
            ))}
          </div>
        ) : paymentHistoryDetails !== undefined &&
          Object.keys(paymentHistoryDetails).length !== 0 ? (
          <div className="grid grid-cols-2 mt-5 gap-10">
            {/*Comtracked */}
            <div className="grid max-w-[90%] pl-12">
              <div className=" leading-7 font-medium flex flex-col text-sm">
                <span className="flex">
                  <span className="font-montserrat font-light text-[28px] text-[#2E2E2E]">
                    C
                  </span>
                  <span className="font-montserrat font-light tracking-[0.2em] pl-[4px] text-lg text-[#2E2E2E]">
                    OMTRACKED
                  </span>
                </span>
                <p>COMTRACKED LTD</p>
                <p>128 City Road</p>
                <p>London</p>
                <p>EC1v 2NX</p>
                <p>United Kingdom</p>
              </div>
            </div>
            {/* Received From */}
            <div className="ml-5">
              <p className="text-base font-bold">Received from</p>
              <div className="leading-7 font-medium text-sm">
                <p>ABC Recruitment Ltd.</p>
                <p>12 Hight Road</p>
                <p>London</p>
                <p>NW10 SRJ</p>
                <p>United Kingdom</p>
              </div>
              <div className="leading-8 text-sm font-normal grid grid-cols-2 lg:grid-cols-3 lg:truncate xl:gap-x-14">
                <p> Member reference :</p>
                <p className="font-medium pl-2 lg:pl-7 xl:pl-0 lg:col-span-2">
                  {paymentHistoryDetails?.recruiterDetails?.refNo || "NA"}{" "}
                </p>
                <p>Date :</p>
                <p className="font-medium pl-2 lg:pl-7 xl:pl-0 lg:col-span-2">
                  {paymentHistoryDetails?.createdAt
                    ? dayjs(paymentHistoryDetails?.createdAt).format(
                        "Do MMMM, YYYY"
                      )
                    : "NA"}
                </p>
              </div>
            </div>
            {/* left side */}
            <div className="grid gap-y-10 pl-12">
              {type === "referralpayment" ? (
                <div>
                  <p className="text-base font-bold border-b pb-2 mb-5 mr-10">
                    Referral fee recipient
                  </p>
                  <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-y-3 text-sm xl:gap-x-14">
                    <p className="min-w-[100px]">Reference :</p>
                    <p className="lg:col-span-2 lg:pl-10 xl:pl-0  font-medium ">
                      {paymentHistoryDetails?.referralDetails?.refNo || "NA"}
                    </p>
                    <p className="">Name :</p>
                    <p className="lg:col-span-2 lg:pl-10 xl:pl-0 font-medium truncate">
                      {paymentHistoryDetails?.referralDetails?.firstName ||
                        "NA"}{" "}
                      {paymentHistoryDetails?.referralDetails?.lastName || "NA"}
                    </p>
                    <p className="">Username :</p>
                    <p
                      className="lg:col-span-2 lg:pl-10 xl:pl-0 text-[#03A9F4] font-medium truncate cursor-pointer"
                      onClick={() =>
                        navigate(
                          `/transactions/user-details/${paymentHistoryDetails?.referralDetails?._id}/${paymentHistoryDetails?.jobDetails?._id}`
                        )
                      }
                    >
                      {paymentHistoryDetails?.referralDetails?.userName || "NA"}
                    </p>
                  </div>
                </div>
              ) : type === "subscription" ? (
                <div>
                  <p className="text-base font-bold border-b pb-2 mb-5 mr-10">
                    Subscription Details
                  </p>
                  <p className="text-sm font-medium pb-3">Premium membership</p>
                  <p className="text-sm font-medium">
                    {paymentHistoryDetails?.subscriptionDetails
                      ? paymentHistoryDetails?.subscriptionDetails?.type ===
                        "month"
                        ? "Monthly"
                        : "Yearly"
                      : "NA"}{" "}
                    billing
                  </p>
                </div>
              ) : null}
              {(type === "jobpost" || type === "referralpayment") && (
                <div>
                  <p className="text-base font-bold border-b pb-2 mb-5 mr-10">
                    Job {type === "jobpost" ? "Post" : "Details"}
                  </p>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-y-3 text-sm xl:gap-x-14">
                    <p>Reference : </p>
                    <p className="lg:col-span-2 lg:pl-10 xl:pl-0  font-medium">
                      {paymentHistoryDetails?.jobDetails?.refNo || "NA"}
                    </p>
                    <p>Title : </p>
                    <p className="lg:col-span-2 lg:pl-10 xl:pl-0 font-medium">
                      {paymentHistoryDetails?.jobDetails?.title || "NA"}
                    </p>
                  </div>
                </div>
              )}
              {type === "referralpayment" ? (
                <div className="">
                  <p className="text-base font-bold border-b pb-2 mb-5 mr-10">
                    Candidate Placed
                  </p>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-y-3 text-sm xl:gap-x-14">
                    <p>Reference :</p>
                    <p className="lg:col-span-2 lg:pl-10 xl:pl-0  font-medium">
                      {paymentHistoryDetails?.candidateDetails?.refNo || "NA"}
                    </p>
                    <p>Name :</p>
                    <p className="lg:col-span-2 lg:pl-10 xl:pl-0  font-medium">
                      {paymentHistoryDetails?.candidateDetails?.firstName ||
                        "NA"}{" "}
                      {paymentHistoryDetails?.candidateDetails?.lastName || ""}
                    </p>
                    <p>Username :</p>
                    <p
                      className="lg:col-span-2 lg:pl-10 xl:pl-0  font-medium text-[#03A9F4] cursor-pointer"
                      onClick={() =>
                        navigate(
                          `/transactions/user-details/${paymentHistoryDetails?.candidateDetails?.userId}/${paymentHistoryDetails?.jobDetails?._id}`
                        )
                      }
                    >
                      {paymentHistoryDetails?.candidateDetails?.userName ||
                        "NA"}
                    </p>
                  </div>
                </div>
              ) : (
                type === "jobpost" && (
                  <div className="">
                    <p className="text-base font-bold border-b pb-2 mb-5 mr-10">
                      Posted by
                    </p>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-y-3 text-sm xl:gap-x-14">
                      <p>Name : </p>
                      <p className="lg:col-span-2 lg:pl-10 xl:pl-0 font-medium">
                        {paymentHistoryDetails?.recruiterDetails?.firstName ||
                          "NA"}{" "}
                        {paymentHistoryDetails?.recruiterDetails?.lastName ||
                          " "}
                      </p>
                      <p>Reference : </p>
                      <p className="lg:col-span-2 lg:pl-10 xl:pl-0  font-medium">
                        {paymentHistoryDetails?.recruiterDetails?.refNo || "NA"}
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
            {/* right side */}
            <div className="grid max-w-[95%]">
              <div>
                <p className="text-base font-bold border-b pb-2 mb-5 ml-5">
                  Payment Details
                </p>
                <div className="border-b pb-5 grid grid-cols-2 lg:grid-cols-3 lg:truncate xl:gap-x-14 font-normal text-sm ml-5 gap-y-5">
                  <p>
                    {type === "referralpayment"
                      ? "Referral fee"
                      : "Membership fee"}
                    :{" "}
                  </p>
                  <p className="lg:col-span-2 pl-2 lg:pl-7 xl:pl-0 font-medium">
                    £{" "}
                    {type == "referralpayment" &&
                    paymentHistoryDetails?.jobDetails?.referralAmount
                      ? paymentHistoryDetails?.jobDetails?.referralAmount.toFixed(
                          2
                        )
                      : paymentHistoryDetails?.totalAmount
                      ? paymentHistoryDetails?.totalAmount?.toFixed(2)
                      : "NA"}
                  </p>
                  {type === "referralpayment" && (
                    <>
                      <p>Commission fee: </p>
                      <p className="lg:col-span-2pl-2 lg:pl-7 xl:pl-0 font-medium">
                        £{" "}
                        {paymentHistoryDetails?.totalAmount &&
                        paymentHistoryDetails?.jobDetails?.referralAmount
                          ? (
                              paymentHistoryDetails?.totalAmount -
                              paymentHistoryDetails?.jobDetails?.referralAmount
                            ).toFixed(2)
                          : "NA"}
                      </p>
                    </>
                  )}
                </div>
                <div className="mt-5 border-b pb-5 grid grid-cols-2 lg:grid-cols-3 lg:truncate xl:gap-x-14 font-normal text-sm ml-5">
                  <p>Total : </p>
                  <p className="lg:col-span-2 pl-2 lg:pl-7 xl:pl-0 font-medium">
                    £ {paymentHistoryDetails?.totalAmount.toFixed(2) || 0.0}
                  </p>
                </div>
                <div className="text-sm  mt-10 border rounded px-4 py-4 bg-[#F1F5F9] grid grid-cols-3">
                  <span>Paid</span>
                  <span className="font-medium pl-2 lg:pl-10 xl:pl-8">
                    £ {paymentHistoryDetails?.totalAmount.toFixed(2) || "NA"}
                  </span>
                  <span className="font-medium xl:justify-self-center lg:truncate">
                    {dayjs(paymentHistoryDetails?.createdAt).format(
                      "HH:mm DD/MM/YYYY"
                    ) || "NA"}
                  </span>
                </div>
                <div className="text-sm mt-10 grid grid-cols-3 lg:truncate ml-5">
                  <span className="">Payment method :</span>
                  <div className="font-medium pl-2 lg:pl-9 xl:pl-7 col-span-2">
                    <span className="pr-2">Card ending</span>
                    <span className="pr-2">-</span>
                    <span className="font-medium">
                      {paymentHistoryDetails?.last4Digit
                        ? paymentHistoryDetails?.last4Digit
                        : paymentHistoryDetails?.paymentMethodDetails?.last4 ||
                          "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <h1 className="no-print">Details not found</h1>
          </>
        )}
      </div>
    </div>
  );
};

export default TransactionDetailPage;
